module.exports = __webpack_public_path__ + "fonts/question-bg-empty.svg";